import { useMemo } from 'react';
import { CoachSession } from '@airreading/common/data';
import { getDialogSubstituteCoachConflictText } from '@/lib/coach-utils';
import { CustomDialog } from '@/components/ui/custom-dialog';

interface OverlappingSessionsModalProps {
  coachSession: CoachSession;
  open: boolean;
  setOpen: (open: boolean) => void;
  onConfirm: () => void;
  loading?: boolean;
}

export function OverlappingSessionsModal({
  coachSession,
  open,
  setOpen,
  onConfirm,
  loading = false,
}: OverlappingSessionsModalProps) {
  const { title, description, confirmationText } = useMemo(
    () => getDialogSubstituteCoachConflictText(coachSession),
    [coachSession],
  );

  return (
    <CustomDialog
      confirmButtonText="Override and assign"
      onConfirm={onConfirm}
      open={open}
      setOpen={setOpen}
      title="Overlapping Sessions Warning"
      text={title}
      loading={loading}
    >
      <input
        className="w-full rounded-md border border-gray-300 border outline-none px-3 py-2 mt-2"
        readOnly
        value={description}
      />
      <p className="mt-4 text-md text-air-primary text-wrap">{confirmationText}</p>
    </CustomDialog>
  );
}
